import { ReactElement, useEffect, useState } from 'react'
import { getIntegrationConnectUrl } from 'services/integrations/stripe'
import Translation from '../../../Translation'
import { IntegrationCardProps } from '../types'
import { IntegrationsCard } from './Card'

export function IntegrationCards({
    location,
    integrations,
    refreshTenantIntegration
}: {
    location: Record<string, string>
    integrations: {
        available: IntegrationCardProps[]
        enabled: IntegrationCardProps[]
    }
    refreshTenantIntegration(): void
}) {
    const [records, setRecords] = useState<IntegrationCardProps[]>([])

    useEffect(() => {
        let additional: IntegrationCardProps[] = []
        integrations.available.forEach(
            (integration:IntegrationCardProps) => {
                let record: IntegrationCardProps = {
                    ...integration,
                    connect_url: getIntegrationConnectUrl(
                        integration.name,
                        [`integration_id=${integration.id}`]
                    ),
                }

                // e.location_id == location.id

                integrations.enabled
                    .filter(
                        (e: IntegrationCardProps) =>
                            integration.id == e.integration_id
                    )
                    .forEach((e: IntegrationCardProps) => {
                        record = {
                            ...record,
                            ...e,
                            name: record.name,
                            id: integration.id,
                            tenant_integration_id: e.id,
                            category_name: integration.category_name
                        }

                        const existing = additional.filter(
                            ({ id }) => id == record.id
                        )

                        if (
                            existing.length > 0 &&
                            e.location_id &&
                            existing[0].location_id != e.location_id
                        ) {
                            additional.push(record)
                        }
                    })
                if (
                    additional.filter(
                        (existing) =>
                            existing.id == record.id &&
                            existing.location_id != location.id
                    ).length == 0
                ) {
                    additional.push(record)
                }
            }
        )
        setRecords(additional)
    }, [integrations.available, integrations.enabled])

    const Elements: ReactElement[] = records.map(
        (integration: IntegrationCardProps, idx: number) => (
            <IntegrationsCard
                key={`card-${idx}` || integration.id}
                integration={integration}
                integration_location_id={integration.location_id as string}
                location_id={location.id}
                refreshTenantIntegration={refreshTenantIntegration}
            />
        )
    )

    return (
        <div>
            <Translation
                content_key="payment_processor"
                render_as="div"
                className="font-semibold"
            />
            <section className="w-full grid lg:grid-cols-2 gap-3 mt-4">
                <div className="flex">{Elements}</div>
            </section>
        </div>
    )
}

